import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-out',
  templateUrl: './item-out.component.html',
  styleUrls: ['./item-out.component.scss']
})
export class ItemOutComponent implements OnInit {

  title : string = "إذن صرف";
  type :string =  "out";
  isInventory : boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
